<template>
  <div class="info">
    <category
      v-if="isShowCategory"
      style="height: 2.5rem"
      :list="itemList"
      :current="contentParams"
      @changeCurrent="changeParams"
    />

    <div class="infinite-list-wrapper" style="overflow: auto">
      <ul
        class="categoryContent"
        v-infinite-scroll="load"
        infinite-scroll-disabled="disabled"
        :style="{ height: `${contentHeight}rem` }"
      >
        <div>
          <el-carousel
            height="100px"
            style="margin: 0px 10px"
            indicator-position="none"
          >
            <el-carousel-item
              v-for="(item, key) in advertisementsList"
              :key="key"
            >
              <img
                @click="gotoURL(item.link)"
                :src="item.url"
                style="width: 100%; border-radius: 5px"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div v-if="labelList.length > 0" class="tagDiv">
          标签:
          <span
            class="tagLabel"
            v-for="(item, key) in labelList"
            :key="key"
            @click="handleTopic(item)"
          >
            {{ item }}
          </span>
        </div>
        <li
          class="categoryDiv"
          v-for="(item, key) in contentInfoList"
          :key="key"
          @click="handleDetail(item.id, InfoObject.code)"
        >
          <!-- <div class="title">{{ item.title }}</div> -->
          <div style="display: flex; justify-content: space-between">
            <div
              style="
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                width: calc(100% - 120px);
              "
            >
              <div style="font-size: 16px">{{ item.title }}</div>
              <div v-if="isShowCategory">
                <span style="color: #999999; font-size: 14px">{{
                  item.authorName
                }}</span>
                <span style="color: #999999; font-size: 14px">
                  {{ item.readNumber | formatReadNumber }}阅读
                </span>
              </div>
            </div>
            <img
              :src="`${item.coverList[0]}`"
              style="width: 120px; height: 80px"
            />
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
            v-if="!isShowCategory"
          >
            <div>
              <span
                style="
                  color: #ffae18;
                  font-size: 12px;
                  background: rgba(255, 241, 240, 1);
                  padding: 0px 10px;
                  border-radius: 5px;
                  margin-right: 10px;
                "
                >{{ item.categoryName }}</span
              >
              <span style="color: #999999; font-size: 14px">{{
                item.authorName
              }}</span>
            </div>
            <div style="color: #999999; font-size: 14px">
              {{ item.readNumber | formatReadNumber }}阅读
            </div>
          </div>
          <!-- <div>
            <span
              style="
                color: #ef8260;
                border: 1px solid #ef8260;
                padding: 0px 5px;
                border-radius: 5px;
                display: inline-block;
              "
              >{{ item.categoryName }}</span
            >
            <span style="color: #999999">{{ item.authorName }}</span>
            <span style="color: #999999"
              >{{ item.readNumber | formatReadNumber }}阅读</span
            >
            <span style="color: #999999">{{ item.createTime }}</span>
          </div> -->
        </li>
      </ul>
      <!-- <p v-if="loading">加载中...</p>
      <p v-if="noMore">没有更多了</p>-->
    </div>
  </div>
</template>
<script>
import * as request from "@/utils/request";
import { getImageURL } from "@/utils/zgly-utils.js";
import category from "@/components/category";
export default {
  props: ["isShowCategory", "origin"],
  components: {
    category,
  },
  created() {},
  mounted() {
    this.getInfoClass();
    this.contentHeight = document.documentElement.clientHeight / 16 - 9;
  },
  filters: {
    formatReadNumber(val) {
      return val > 10000 ? `${(val / 10000).toFixed(2)}万` : val;
    },
  },
  data() {
    return {
      VUE_APP_BASE_API: process.env.VUE_APP_BASE_API,
      InfoObject: {},
      itemList: [],
      contentInfoList: [],
      labelList: [],
      contentInfoListTotal: 0,
      currentContentId: "",
      contentParams: {
        categoryId: "",
        page: 1,
        size: 10,
      },
      advertisementsList: {},
      loading: false,
      contentHeight: 0,
    };
  },
  computed: {
    noMore() {
      return (
        this.contentParams.page * this.contentParams.size >
        this.contentInfoListTotal
      );
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  methods: {
    getInfoClass() {
      request.getDicts().then((res) => {
        this.InfoObject = res.data.filter((item) => item.value === "资讯")[0];
        this.getItemList();
      });
      if (!this.isShowCategory) {
        request
          .getPosters({
            type: "NEWS_CAROUSEL",
          })
          .then((res) => {
            if (res.code == 0) {
              this.advertisementsList = res.data;
            }
          });
      }
    },
    getCategoriesPoster() {
      request
        .getCategoriesPosters({
          id: this.contentParams.categoryId,
        })
        .then((res) => {
          if (res.code == 0) {
            this.advertisementsList = res.data;
          }
        });
    },
    getCategoriesLabels() {
      request
        .getCategoriesLabels({
          id: this.contentParams.categoryId,
        })
        .then((res) => {
          if (res.code == 0) {
            this.labelList = res.data;
          }
        });
    },
    getItemList() {
      request.getCategoriesByType(this.InfoObject.code).then((res) => {
        this.itemList = res.data;
        this.itemList.length > 0 &&
          this.isShowCategory &&
          (this.contentParams.categoryId = this.itemList[0].id);
        if (this.isShowCategory) {
          this.getCategoriesPoster();
          this.getCategoriesLabels();
        }
        this.getContentInfo();
      });
    },
    getContentInfo() {
      request.getResourceNews(this.contentParams).then((res) => {
        this.contentInfoList = this.contentInfoList.concat(res.data.list);
        this.contentInfoList = this.contentInfoList.map((_) => {
          _.coverList = this.parseUrl(_.cover);
          _.coverList = _.coverList.splice(0, 3);
          return _;
        });
        this.contentInfoListTotal = res.data.total;
      });
    },
    changeParams(val) {
      this.contentParams = {
        categoryId: val,
        page: 1,
        size: 10,
      };
      if (this.isShowCategory) {
        this.getCategoriesPoster();
        this.getCategoriesLabels();
      }
      this.contentInfoList = [];
      this.getContentInfo();
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.contentParams.page += 1;
        this.getContentInfo();
        this.loading = false;
      }, 2000);
    },
    handleDetail(id, type) {
      if (this.origin) {
        this.$router.push({
          path: `/news/details/${id}?type=${type}&category=${this.origin}&recom=info`,
        });
      } else {
        this.$router.push({
          path: `/news/details/${id}?type=${type}&category=info`,
        });
      }
    },
    parseUrl(url) {
      let imgArr = url.split(",");
      if (typeof imgArr === "string") {
        imgArr = [imgArr];
      }
      imgArr = imgArr.map((_) => {
        _ = this.getImageURL(_);
        return _;
      });
      return imgArr;
    },
    getImageURL(cover) {
      return getImageURL(cover);
    },
    handleTopic(val) {
      request
        .getTopics({
          topic: val,
        })
        .then((res) => {
          if (res.data) {
            this.$router.push({
              path: `/account?topic=${val}`,
            });
          } else {
            this.$router.push({
              path: `/search?content=${val}`,
            });
          }
        });
    },
    gotoURL(url) {
      console.log(url);
      window.location.href = url;
    },
  },
};
</script>
<style lang="less" scope>
.info {
  .categoryContent {
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    list-style: none;
    padding: 0px;
    .categoryDiv {
      padding: 0.5rem 1rem;
      border-bottom: 1px solid #ccc;
      .title {
        padding: 0.5rem 0rem;
      }
    }
  }
  .tagDiv {
    margin-top: 10px;
    padding: 10px;
    height: 50px;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    // ::-webkit-scrollbar:;
    .tagLabel {
      background: rgba(153, 153, 153, 1);
      color: #fff;
      border-radius: 20px;
      font-size: 14px;
      padding: 5px 10px;
      margin: 0px 5px;
    }
  }
}
</style>

